const snackbarContent = {
  root: {
    '@media (min-width: 960px)': {
      borderRadius: 8,
    },
  },
};

export default snackbarContent;
